// removed by extract-text-webpack-plugin
module.exports = {"list__data":"SimpleList-hashed__list__data__1fY8-","list__dataLabel":"SimpleList-hashed__list__dataLabel__r4zDE"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/subdirectives/list/SimpleList/SimpleList-hashed.scss
// module id = 1239
// module chunks = 0